import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { isHomePage } from '../../../modules/types';
import getBreadcrumbTrail from '../../../modules/breadcrumbs';

const propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  page: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
  site: PropTypes.shape({
    siteUrl: PropTypes.string.isRequired,
    customCompanyName: PropTypes.string,
  }).isRequired,
  breadcrumbTrail: PropTypes.shape({
    name: PropTypes.string,
    parentPage: PropTypes.shape({
      title: PropTypes.string,
      breadcrumbTrail: PropTypes.shape({
        name: PropTypes.string,
        ancestorPages: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            breadcrumbTrail: PropTypes.shape({
              name: PropTypes.string,
            }),
          }),
        ),
      }),
    }),
  }),
};

const defaultProps = {
  breadcrumbTrail: undefined,
};

const BreadcrumbTrail = ({ page, site, breadcrumbTrail }) => {
  const {
    title,
  } = page;
  const {
    customCompanyName,
  } = site;

  const breadcrumbName = get(breadcrumbTrail, 'name', title);

  const parentPageType = get(breadcrumbTrail, 'parentPage.pageType.code');
  const isParentPageHome = isHomePage(parentPageType);

  if (isParentPageHome) {
    return (
      <React.Fragment>
        {`${customCompanyName} / ${breadcrumbName}`}
      </React.Fragment>
    );
  }

  const trail = getBreadcrumbTrail(
    customCompanyName,
    get(breadcrumbTrail, 'parentPage'),
  );

  return (
    <React.Fragment>
      {`${trail} / ${breadcrumbName}`}
    </React.Fragment>
  );
};

BreadcrumbTrail.propTypes = propTypes;
BreadcrumbTrail.defaultProps = defaultProps;

export default BreadcrumbTrail;
